import React from 'react';
import Card from '@material-ui/core/Card';
import IconButton from '@material-ui/core/IconButton';
import CardHeader from '@material-ui/core/CardHeader';
import ViewComfy from '@material-ui/icons/ViewComfy';
import CardContent from '@material-ui/core/CardContent';
import InputComp from '../../components/InputComp';
import Button from '@material-ui/core/Button';
import CardActions from '@material-ui/core/CardActions';
import Snackbar from '@material-ui/core/Snackbar';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogActions from '@material-ui/core/DialogActions';
import Dialog from '@material-ui/core/Dialog';
import getLabelUrl from '../../helpers/unileverSales/getLabelUrl';

const OperatorGroupsFormEdit = (props) => {
  const {
    toggleDeleteModalVisibility, deleteModalVisible,
    deleteOperatorGroup, operatorGroup, errorMessage, clearErrorMessage
  } = props;
  return (
    <div className="col-md-12">
      {errorMessage ? <Dialog
        open={true}
        onClose={() => clearErrorMessage()}
      >
        <DialogTitle>{"Cannot delete operator group!"}</DialogTitle>
        <DialogContent>
          <DialogContentText >
            {errorMessage}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => {
              clearErrorMessage()
            }}
            color="primary"
            autoFocus
          >
            OK
          </Button>
        </DialogActions>
      </Dialog> : null}
      <Dialog
        open={deleteModalVisible}
        onClose={() => toggleDeleteModalVisibility()}
      >
        <DialogTitle>{"Delete Operator Group"}</DialogTitle>
        <DialogContent>
          <DialogContentText >
            Are you sure you want to delete the selected operator group?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => {
              deleteOperatorGroup(operatorGroup.id)
            }}
            color="primary"
            autoFocus
          >
            Delete
          </Button>
          <Button
            onClick={() => toggleDeleteModalVisibility()}
            color="secondary">
            Cancel
          </Button>
        </DialogActions>
      </Dialog>
      <Card>
        <CardHeader
          avatar={
            <IconButton>
              <ViewComfy/>
            </IconButton>
          }
          title={"Edit operator group"}
        />
        <CardContent>
          <div className="col col-lg-4 offset-lg-3">
            <form id="form-brand" className="form-horizontal" onSubmit={props.handleSubmit}>
              {operatorGroup ?
                <InputComp
                  Value={operatorGroup.name}
                  Label="Name"
                  Name="name"
                  Type="text"
                  Required={true}
                  fullWidth={true} margin={'normal'}
                  placeholder="name"
                  PropHandleInputChange={props.handleNameChange}
              /> : null}
            </form>
          </div>
          <CardActions>
            <Button
              color="primary"
              variant="contained"
              form="form-brand"
              type="submit">
              Edit
            </Button>
            <Button
              onClick={() => toggleDeleteModalVisibility()}
              color="secondary"
              variant="contained">
              Delete
            </Button>
          </CardActions>
        </CardContent>
      </Card>
      <Snackbar
        open={props.formWarningOpen}
        message={props.formWarningOpen}
        autoHideDuration={6000}
      />
    </div>
  );
};

export default OperatorGroupsFormEdit;



// WEBPACK FOOTER //
// ./src/containers/OperatorGroups/OperatorGroupsFormEdit.js